// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"TableHead_tableHead__1ABIt"};